/*
 * SVG Editor
 * version: 1.0.1
 *
 */
/* eslint-disable */
import { useState, useEffect } from 'react';
import Notification from './components/Notification';
import Button from './components/Button';
import Toolbar from './components/Toolbar';
import FabricCanvas from './components/FabricCanvas';
import ToolPanel from './components/ToolPanel';
import SelectionSettings from './components/SelectionSettings';
import CanvasSettings from './components/CanvasSettings';
import DrawSettings from './components/DrawSettings';
import Shapes from './components/Shapes';
import UploadSettings from './components/UploadSettings';
import Layers from './components/Layers';
import {
  ImageIcon, Edit2Icon, ShirtIcon, PaletteIcon, DownloadIcon, PersonStanding, LightbulbIcon, TypeIcon, UploadIcon, PaintBucketIcon,
  SquareAsteriskIcon, Undo2Icon, Redo2Icon, MousePointer2Icon, SearchIcon, MoonIcon, SunIcon, ShapesIcon, VideoIcon,
  MousePointer2OffIcon, TrashIcon, GridIcon, DropletIcon, MousePointer, RotateCcw, Move, Target,
  NotebookPenIcon,
  Layers2Icon,
  GemIcon,
  PrinterCheck,
  SaveIcon,
  BarChart3
} from "lucide-react";
import EditorExtras from "./components/EditorExtras"
import DTF from "./components/DTF"
import ColorRandom from "./components/ColorRandom"
import TextScreen from "./components/TextScreen"
import ClipartsScreen from "./components/ClipartsScreen"
import BackgroundScene from './components/BackgroundScene';
import Music from './components/Music';
import Transitions from './components/Transitions';
import ChangeSport from './components/ChangeSport';
import UploadCustom from './components/UploadCustom';
import VideoMenu from './components/Video';
import Animation from './components/Animation';
import Material from './components/Material';
import DownloadSidebar from './components/Download';
import Annotation from './components/Annotation';
import Clone from './components/Clone';
import AnimationState from './components/AnimationState';
import FpsState from './components/FpsState';
import TextState from './components/TextState';
import ObjState from './components/ObjState';
import Favorites from './components/Favorites';
import RenderState from './components/RenderState';
import TextCustom from './components/TextCustom';
import Light from './components/Light';
import LightState from './components/LightState';
import MultipleState from './components/MultipleState';
import ModularState from './components/ModularState';
import ModularPartSelector from './components/ModularPartSelector';
import Cloth from './components/Cloth';
import __ from './utils/translation';
import saveInBrowser from './utils/saveInBrowser';
import { undo, redo } from './utils/undoRedo';
import { editorTips } from './utils/editorTips';
import { handleDrawingModes } from './utils/handleDrawingModes';
import { applyZoom, zoomWithKeys, zoomWithMouse, zoomOptions } from './utils/zoom';
import { ReactComponent as IconZoom } from './icons/zoom.svg';
import { useSignOut } from "react-auth-kit";
import { useIsAuthenticated } from 'react-auth-kit';
import $ from "jquery";
import { Projects } from "./projects";
import { getClient, countNewIframeOrders, getUserId } from "./API";
import { supabase } from "./supabaseClient";
import { IframeOrdersModal } from "./components/IframeOrdersModal";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card"
import { ProjectsModal } from "./js/simulador/clients/clients-modal";
import { ArrowBack, Logout } from '@mui/icons-material';
import { TakeEditor } from './js/simulador/video/take-editor';
import { ModalTresBotoes } from "./components/ModalTresBotoes";
import { ReloadIcon } from '@radix-ui/react-icons';
import { SaveProjectModal } from "./components/SaveProjectModal";
import { AdminDashboard, isAdmin } from "./components/AdminDashboard";
// 1. Importe
import TutorialModal, { TutorialButton } from './js/simulador/TutorialModal';

const flags = {
  PT: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 504" width="28" height="19">
      <rect width="720" height="504" fill="#009C3B" />
      <polygon points="360,40 680,252 360,464 40,252" fill="#FFDF00" />
      <circle cx="360" cy="252" r="108" fill="#002776" />
      <path d="M252,216 a108,108 0 0,1 216,0" fill="none" stroke="white" strokeWidth="18" />
      <rect x="252" y="234" width="216" height="36" fill="white" />
      <text x="360" y="264" textAnchor="middle" fontSize="28" fill="#002776" fontFamily="Arial" fontWeight="bold">BRASIL</text>
    </svg>
  ),
  ES: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" width="28" height="19">
      <rect width="750" height="500" fill="#AA151B" />
      <rect y="125" width="750" height="250" fill="#F1BF00" />
    </svg>
  ),
  EN: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="28" height="19">
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="white" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 V30 M0,15 H60" stroke="white" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  ),
};

const Simulator = () => {

  window.canvasLoaded = false;

  const [showTutorial, setShowTutorial] = useState(false);

  const singOut = useSignOut();
  const [isModalOpen, setIsModalOpen] = useState(false)

  window['singOut'] = function () {
    singOut();
    window.open(window.location.origin, "_self");
  }

  const isAuthenticated = useIsAuthenticated();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var is_iframe = urlParams.get('i');

  if (!is_iframe) {
    import('./editor.js?version=2')
      .then((module) => {
        if (window.name == "not-logged" && isAuthenticated()) {//
          window.name = "logged";
        }
      });
  }

  // states
  const [notification, setNotification] = useState({ message: null, type: null, seconds: null })
  const [activeTool, setActiveTool] = useState('select')
  useEffect(() => { window.setActiveTool = setActiveTool }, [])

  // ── Cargo do usuário logado (vendedor/designer), pra simplificar a UI ──
  const [userRole, setUserRole] = useState(null)
  useEffect(() => {
    (async () => {
      try {
        const client = await getClient(getUserId())
        if (client && client[0]) setUserRole(client[0].role || null)
      } catch (e) {
        console.error("Erro ao buscar cargo do usuário:", e)
      }
    })()
  }, [])
  const isVendedor = userRole === 'vendedor'
  const [canvas, setCanvas] = useState()
  const [loadSavedCanvas, setLoadSavedCanvas] = useState(true)
  const [activeSelection, setActiveSelection] = useState(null)
  const [history, setHistory] = useState({ index: null, states: [] })
  const [selectionInfo, setSelectionInfo] = useState(editorTips[Math.floor(Math.random() * editorTips.length)])
  const [zoom, setZoom] = useState(1)
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [currentProjectData, setCurrentProjectData] = useState(null);
  const [isIframeOrdersOpen, setIsIframeOrdersOpen] = useState(false);
  const [newIframeOrdersCount, setNewIframeOrdersCount] = useState(0);
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  const languages = [
    { code: 'PT', flag: '🇧🇷', label: 'Português' },
    { code: 'ES', flag: '🇪🇸', label: 'Español' },
    { code: 'EN', flag: '🇺🇸', label: 'English' },
  ];
  const [langIndex, setLangIndex] = useState(0);

  // ── Balão de notificação: pedidos novos do iframe ────────────────────────
  // Conta pedidos chegados desde a última vez que essa loja abriu a tela de
  // "Pedidos do Iframe" (guardado no localStorage), e atualiza ao vivo via
  // Realtime enquanto essa tela do editor estiver aberta.
  useEffect(() => {
    const userId = getUserId();
    if (!userId) return;

    const lastSeenKey = `iframeOrdersLastSeen_${userId}`;
    const lastSeen = localStorage.getItem(lastSeenKey);

    countNewIframeOrders(userId, lastSeen)
      .then((count) => setNewIframeOrdersCount(count))
      .catch((e) => console.error("[Simulator] erro ao contar novos pedidos:", e));

    const channel = supabase
      .channel(`iframe_projects_notify_${userId}`)
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "iframe_projects", filter: `user_id=eq.${userId}` },
        () => setNewIframeOrdersCount((prev) => prev + 1)
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  // Chamado ao abrir a tela de pedidos — zera o balão e marca "visto agora".
  const openIframeOrders = () => {
    const userId = getUserId();
    if (userId) {
      localStorage.setItem(`iframeOrdersLastSeen_${userId}`, new Date().toISOString());
    }
    setNewIframeOrdersCount(0);
    setIsIframeOrdersOpen(true);
  };

  const handleLangChange = () => {
    const nextIndex = (langIndex + 1) % languages.length;
    setLangIndex(nextIndex);
    // Disparar evento para o restante do sistema (compatível com ApplyLanguage existente)
    const event = new CustomEvent('languageChange', { detail: languages[nextIndex].code.toLowerCase() });
    window.dispatchEvent(event);
  };

  // on start: check if there is a saved canvas in this browser and ask if we should load it
  useEffect(() => {
    if (canvas && loadSavedCanvas) {
      const savedCanvas = saveInBrowser.load('canvasEditor');
      if (savedCanvas && window.confirm(__('We found a project saved in this browser! Do you want to load it?'))) {
        canvas.loadFromJSON(savedCanvas, canvas.renderAll.bind(canvas));
      }

      setLoadSavedCanvas(false);
    }
  }, [canvas, loadSavedCanvas])

  // on active selection update: change active tool to select
  useEffect(() => {
    if (!activeSelection) return

    setActiveTool('select');

    if (activeSelection.lockMovementX) {
      $("#obj-unlocked").css("display", "none");
      $("#obj-locked").css("display", "block");
    } else {
      $("#obj-unlocked").css("display", "block");
      $("#obj-locked").css("display", "none");
    }

    // scroll to top in tool panel
    document.querySelector('.toolpanel .holder').scrollTop = 0

    window["ApplyLanguage"]();
  }, [activeSelection])

  // on active tool change: deselect all object, handle drawing modes
  useEffect(() => {
    if (!canvas) return

    //if (activeTool !== 'select') canvas.discardActiveObject().requestRenderAll()

    handleDrawingModes(canvas, activeTool, setSelectionInfo)
  }, [canvas, activeTool])

  // save history and unsaved work alert
  const maxHistory = 10
  useEffect(() => {
    if (!canvas) return

    const saveHistory = () => {
      let updatedHistory = [...history.states]

      // if any action happens after undo, clear all (redo) actions after current state
      if (history.index < history.states.length - 1) updatedHistory.splice(history.index + 1)

      // add current state to history
      updatedHistory.push(canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY',
        'hasControls', 'default', 'id', 'scaleX', 'scaleY']))
      if (updatedHistory.length > maxHistory) updatedHistory.shift()

      setHistory({ index: updatedHistory.length - 1, states: updatedHistory })
    }
    canvas.on('object:modified', saveHistory)
    canvas.on('path:created', saveHistory)

    const unsavedWorkAlert = (e) => {
      if (history.states.length > 1) e.returnValue = __(`Are you sure you want to leave?`)
    }
    window.addEventListener('beforeunload', unsavedWorkAlert)

    // cleanup
    return () => {
      canvas.off('object:modified', saveHistory)
      canvas.off('path:created', saveHistory)

      window.removeEventListener('beforeunload', unsavedWorkAlert)
    }
  }, [canvas, history])

  // keyboard & mouse shortcuts
  useEffect(() => {
    if (!canvas) return

    // select tool (v)
    const keyV = (e) => {
      const key = e.which || e.keyCode;
      if (key === 86 && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        //setActiveTool('select')
      }
    }
    document.addEventListener('keydown', keyV)

    // undo/redo (ctrl z/y)
    const ctrZY = (e) => {
      const key = e.which || e.keyCode;

      if (key === 90 && e.ctrlKey && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        undo(canvas, history, setHistory)
      }

      if (key === 89 && e.ctrlKey && document.querySelectorAll('textarea:focus, input:focus').length === 0) {
        redo(canvas, history, setHistory)
      }
    }
    document.addEventListener('keydown', ctrZY)

    // zoom out/in/reset (ctr + -/+/0)
    const keyZoom = (e) => zoomWithKeys(e, canvas, setZoom, applyZoom)
    document.addEventListener('keydown', keyZoom)

    // zoom out/in with mouse
    const mouseZoom = (e) => zoomWithMouse(e, canvas, setZoom, applyZoom)
    document.addEventListener('wheel', mouseZoom, { passive: false })

    // cleanup
    return () => {
      document.removeEventListener('keydown', keyV)
      document.removeEventListener('keydown', ctrZY)
      document.removeEventListener('keydown', keyZoom)
      document.removeEventListener('wheel', mouseZoom)
    }
  }, [canvas, history])

  // render layout
  return (
    <div id="app" className='configurator-main'>

      <div id="tutorial-simulador" className="w-full h-full">
        <img id="interaction-icon" src="./hand.svg" alt="Arraste para girar"></img>
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" id="menu-tutorial">
          <Card className="w-full max-w-2xl">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-bold">Controles da Visualização 3D</CardTitle>
              <CardDescription>Aprenda a navegar no ambiente 3D usando o mouse</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              {/* Rotacionar */}
              <div className="flex items-start gap-4 p-4 rounded-lg bg-muted/50">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <RotateCcw className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-2">Rotacionar Objeto</h3>
                  <p className="text-muted-foreground mb-2">
                    Clique e arraste com o <strong>botão esquerdo do mouse</strong> para rotacionar o objeto 3D em todas as
                    direções.
                  </p>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <MousePointer className="w-4 h-4" />
                    <span>Botão esquerdo + arrastar</span>
                  </div>
                </div>
              </div>

              {/* Mover */}
              <div className="flex items-start gap-4 p-4 rounded-lg bg-muted/50">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Move className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-2">Mover Câmera</h3>
                  <p className="text-muted-foreground mb-2">
                    Clique e arraste com o <strong>botão direito do mouse</strong> para mover a câmera e explorar diferentes
                    ângulos.
                  </p>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <MousePointer className="w-4 h-4" />
                    <span>Botão direito + arrastar</span>
                  </div>
                </div>
              </div>

              {/* Recentralizar */}
              <div className="flex items-start gap-4 p-4 rounded-lg bg-muted/50">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Target className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-2">Recentralizar Vista</h3>
                  <p className="text-muted-foreground mb-2">
                    Clique no <strong>botão do meio do mouse</strong> (scroll wheel) para recentralizar a câmera na posição
                    inicial.
                  </p>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <MousePointer className="w-4 h-4" />
                    <span>Botão do meio (scroll wheel)</span>
                  </div>
                </div>
              </div>

              {/* Botões de ação */}
              <div className="flex gap-3 pt-4">
                <Button className="flex-1" id="btn-close-tutorial">
                  Entendi, começar!
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      <div id="tutorial-panel">
        <div id="tutorial-header">
          <span id="title-tutorial">TUTORIAL</span>
          <div id="close-tutorial">
            <button>VOLTAR</button>
          </div>
        </div>

        <div id="tutorial-body">
          <div id="tutorial-left">
            <span className='active' data-link="1">1 - Login, logout, idioma, tela cheia e controles</span>
            <span data-link="2">2 - Mudar esportes</span>
            <span data-link="3">3 - Mudar fundo</span>
            <span data-link="4">4 - Download</span>
            <span data-link="5">5 - Anotação</span>
            <span data-link="6">6 - Apresentação</span>
            <span data-link="7">7 - Lista de pedidos</span>
            <span data-link="8">8 - Material, textura, resolução e  qualidade</span>
            <span data-link="9">9 - Customizar avatar</span>
            <span data-link="10">10 - Animações e poses</span>
            <span data-link="11">11 - Salvar, editar e buscar projeto</span>
            <span data-link="12">12 - Svg-editor parte 1</span>
            <span data-link="13">13 - Svg-editor parte 2</span>
            <span data-link="14">14 - Upload Customizado</span>
            <span data-link="15">15 - Upload cenário</span>
            <span data-link="16">16 - Iframe parte 1</span>
            <span data-link="17">17 - Iframe parte 2</span>
            <span data-link="18">18 - Realidade aumentada</span>
            <span data-link="19">19 - Projetos vindo do cliente pelo iframe</span>
            <span data-link="20">20 - Tabela de cores personalizada</span>
          </div>
          <div id="tutorial-right">
            <div id="tutorial-video">
            </div>
            <div id="tutorial-info">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </div>
          </div>
        </div>
      </div>

      <div id="custom-banner">
        <div id="custom-banner-box">
          <div id="custom-banner-box-input">
            <label className='banner-rec' htmlFor="width-banner">Banner Width (cm)</label>
            <input className='banner-rec' id="width-banner" name="width-banner" type='number' defaultValue="100"></input>
            <label className='banner-rec' htmlFor="height-banner">Banner Height (cm)</label>
            <input className='banner-rec' id="height-banner" name="height-banner" type='number' defaultValue="100"></input>
            <label className='banner-rad' htmlFor="radius-banner">Banner Radius (cm)</label>
            <input className='banner-rad' id="raidus-banner" name="raidus-banner" type='number' defaultValue="100"></input>
          </div>
          <div id="custom-banner-box-buttons">
            <button id="close-custom-banner">Cancel</button>
            <button id="confirm-custom-banner">Confirm</button>
          </div>
        </div>
      </div>

      <div id='configurator2' className='toolbar-buttons'>
        <input id="output-title" placeholder='ORDEM' className='border-[black]'></input>
        {/**<input id="output-title" value="Seu texto aqui" style="position:fixed; top:10px; left:10px; z-index:9999;"></input> */}
        <div className="panel-custom-buttons bg-background text-primary">

          <Button id="undo-svg" className='svg' title={__('Undo')} handleClick={() => undo(canvas, history, setHistory)}
          ><Undo2Icon></Undo2Icon></Button>

          <Button id="redo-svg" className='svg' title={__('Redo')} handleClick={() => redo(canvas, history, setHistory)}
          ><Redo2Icon></Redo2Icon></Button>

          {/*<button className='svg !text-primary' id="canvas-default-size" title='RESET CANVAS ZOOM'>
            <SearchIcon></SearchIcon>
          </button>

          <button title='LIMPAR SVG' id="clear_svg" className='svg'>
            <i className="fas fa-broom icon-svg"></i>
          </button> */}

          <button
            size="lg"
            title={`Idioma: ${languages[langIndex].label} — clique para alternar`}
            className='text-primary hover:bg-primary hover:text-background flex flex-col items-center leading-none'
            id="change-idi"
            onClick={handleLangChange}
          >
            <span style={{ display: 'block', lineHeight: 1, borderRadius: '2px', overflow: 'hidden' }}>
              {flags[languages[langIndex].code]}
            </span>
            <span style={{ fontSize: '0.6rem', marginTop: '2px' }}>{languages[langIndex].code}</span>
          </button>

          <button size="lg" className='text-primary hover:bg-primary hover:text-background' id="theme-change-new" data-panel="panel-projects">
            <MoonIcon id="theme-moon" className=''></MoonIcon>
            <SunIcon id="theme-sun" className='hidden'></SunIcon>
          </button>

          <button title='GERENCIAR PROJETOS' className='bg-[orange] main hover:bg-primary hover:text-background' id="open-folder" data-en='CATALOG' data-pt='CATÁLOGO' data-es="CATALOGO" data-panel="panel-projects">
            <i className="far fa-folder icon-svg"></i>
          </button>

          <div style={{ position: "relative", display: "inline-block" }}>
            <button
              title='PEDIDOS DO IFRAME'
              className='bg-[#2563eb] main'
              onClick={openIframeOrders}>
              <i className="fas fa-clipboard-list icon-svg"></i>
            </button>
            {newIframeOrdersCount > 0 && (
              <span
                style={{
                  position: "absolute", top: 18, right: 30, zIndex: 10,
                  minWidth: 18, height: 18, padding: "0 4px",
                  borderRadius: 999,
                  background: "#ef4444", color: "#fff",
                  fontSize: 10, fontWeight: 700, lineHeight: "18px",
                  textAlign: "center",
                  boxShadow: "0 0 0 2px rgba(0,0,0,0.6)",
                  pointerEvents: "none",
                }}
              >
                {newIframeOrdersCount > 99 ? "99+" : newIframeOrdersCount}
              </span>
            )}
          </div>

          {/**<button onClick={() => setIsModalOpen(true)} size="lg" title='GERENCIAR PROJETOS CLIENTES' className='main hover:bg-primary hover:text-background' id="open-folder-client" data-panel="panel-projects">
            <i className="fas fa-users icon-svg"></i>
          </button> */}

          {!isVendedor && (
            <button
              title='SALVAR PROJETO'
              className='main hover:bg-primary hover:text-background bg-[green]'
              onClick={() => {
                const pd = window.currentProjectData;
                setCurrentProjectData(pd ? {
                  id: pd.id,
                  name: pd.name || "",
                  productionOrder: pd.productionOrder || "",
                  designer: pd.designer || "",
                  file_path: pd.file_path || "",
                } : null);
                setIsSaveModalOpen(true);
              }}
            >
              <SaveIcon></SaveIcon>
            </button>
          )}

          <button
            title='MEUS DADOS'
            className='main hover:bg-primary hover:text-background bg-[#8b5cf6]'
            onClick={() => setIsAdminOpen(true)}
          >
            <BarChart3 className='m-1' style={{ width: 20, height: 20 }} />
          </button>

          <button id="paste-corel" title='COLAR DO COREL DRAW' className='main hover:bg-primary hover:text-background'>
            <i className="fas fa-paste"></i>
          </button>

          <button id="pred-state" className='main hover:bg-primary hover:text-background'>
            <PrinterCheck></PrinterCheck>
          </button>

          {/**<TutorialButton onClick={() => setShowTutorial(true)} />
              <TutorialModal open={showTutorial} onClose={() => setShowTutorial(false)} /> */}

          <button id="btn-log-out" className='main hover:bg-primary hover:text-background '>

            <span className='[writing-mode:vertical-rl] m-1'>SAIR</span>
            <Logout className='m-1'></Logout>
          </button>

          <div id="model-title" className='h-[10px] w-full fixed bottom-0 left-0 bg-red flex justify-center items-center'>
            <span className='w-auto'></span>
          </div>
        </div>
      </div>

      <ModalTresBotoes></ModalTresBotoes>

      <div id="panel-save">
        <div id="panel-box-save">
          <span id="storage-warning">Armazenamento excedido</span>
          <input type="text" id="input-save-name"></input>
          <div>
            <button id="btn-save-cache-confirm">Salvar</button>
            <button id="btn-close-save">Cancelar</button>
          </div>
        </div>
      </div>

      <div className='panel-default'>
        <Projects />
      </div>

      <img id="holding_img"></img>{/**src="/image.svg" */}

      <div id="svg-container"></div>

      <div id="configurator">

        <TakeEditor></TakeEditor>

        <div id="warning">
          <div id="warning-panel">
            <span>AVISO</span>
            <div>
              <button id="btn-1">1</button>
              <button id="btn-2">2</button>
              <button id="btn-3">Cancelar</button>
            </div>
          </div>
        </div>

        <Toolbar activeTool={activeTool} id="toolbar-configurator">
          {isVendedor ? (
            <button className='bg-[blue] hover:bg-primary hover:text-background' id="change-sport-all" data-title="ChangeSport" name="change_sport" title={__('MUDAR MODELO 3D')}><ShirtIcon></ShirtIcon></button>
          ) : (
            <>
              <button className='text-primary' id="multiple-menu" data-title="MultipleState" name="multiple" title={__('OPÇÕES DE ILUMINAÇÃO')} >
                <i className="fas fa-cubes svg-font"></i>
              </button>
              <button className='hover:bg-primary hover:text-background' id="svg-editor-state" title={__('EDITAR MAPA SVG')}><Edit2Icon></Edit2Icon></button>
              <button className='bg-[blue] hover:bg-primary hover:text-background' id="change-sport-all" data-title="ChangeSport" name="change_sport" title={__('MUDAR MODELO 3D')}><ShirtIcon></ShirtIcon></button>
              <button className='hover:bg-primary hover:text-background' data-title="BackgroundScene" name="background_scene" title={__('EDITAR FUNDO')}><ImageIcon></ImageIcon></button>
              <button id="btn-video-app" className='hover:bg-primary hover:text-background' data-title="Video" name="video" title={__('OPÇÕES DE VIDEO')}><VideoIcon></VideoIcon></button>
              <button className='hover:bg-primary hover:text-background' id="cloth-button" data-title="Cloth" name="cloth" title={__('EDITAR MATERIAL')} ><PaletteIcon></PaletteIcon></button>
              <button className='hover:bg-primary hover:text-background' data-title="Download" name="download" title={__('OPÇÕES DE DOWNLOAD')} ><DownloadIcon></DownloadIcon></button>
              <button className='hover:bg-primary hover:text-background' id="obj-state" data-title="ObjState" name="ObjState" title={__('OPÇÕES DE VISIBILIDADE')} >
                <PersonStanding></PersonStanding>
              </button>
              <button className='hover:bg-primary hover:text-background' id="light-menu" data-title="Light" name="Light" title={__('OPÇÕES DE ILUMINAÇÃO')} >
                <LightbulbIcon></LightbulbIcon>
              </button>


              <button className='hover:bg-primary hover:text-background' data-title="Annotation" name="annotation" title={__('Annotation')} ><NotebookPenIcon></NotebookPenIcon></button>

              <button className='hover:bg-primary hover:text-background' data-title="ModularState" name="modular_state" title={__('MODULAR SETUP')} onClick={() => setActiveTool(activeTool === 'modular_state' ? 'select' : 'modular_state')}><Layers2Icon></Layers2Icon></button>
            </>
          )}
        </Toolbar>

        <ToolPanel className="p-2" visible={activeSelection || (
          activeTool !== 'select' && activeTool !== 'line' && activeTool !== 'path' && activeTool !== 'textbox'
        )}>

          <div className='toolpanel_panel p-2' id="BackgroundScene">
            <BackgroundScene canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="Music">
            <Music canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="Transitions">
            <Transitions canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="ChangeSport">
            <ChangeSport canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2' id="UploadCustom">
            <UploadCustom canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2 p-2' id="Video">
            <VideoMenu canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="Animation">
            <Animation canvas={canvas} />
          </div>

          <div className='toolpanel_panel p-2' id="Material">
            <Material canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2 p-2' id="Cloth">
            <Cloth canvas={canvas} />
          </div>

          <div className='toolpanel_panel p-0 p-2' id="Download">
            <DownloadSidebar canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2' id="Annotation">
            <Annotation canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2' id="Clone">
            <Clone canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="AnimationState">
            <AnimationState canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="LightState">
            <LightState canvas={canvas} />
          </div>

          <div className='toolpanel_panel p-2' id="MultipleState">
            <MultipleState canvas={canvas} />
          </div>

          <div className='toolpanel_panel p-2 bg-secondary' id="ModularState">
            <ModularState canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="FpsState">
            <FpsState canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="TextState">
            <TextState canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2' id="ObjState">
            <ObjState canvas={canvas} />
          </div>

          <div className='toolpanel_panel toolpanel_panel2 p-2' id="Light">
            <Light canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="RenderState">
            <RenderState canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="TextCustom">
            <TextCustom canvas={canvas} />
          </div>

          <div className='toolpanel_panel' id="Favorites">
            <Favorites canvas={canvas} />
          </div>
        </ToolPanel>

      </div>

      <div id="svg-editor">

        <div id="panel-editor-options" className='fixed right-0'>
          <section>
            <div className=''>
              <label>Desfazer</label>
              <Button className="w-full bg-transparent" id="undo-svg0">
                <Undo2Icon></Undo2Icon>
              </Button>
            </div>
            <div className=''>
              <label>Refazer</label>
              <Button className="w-full bg-transparent" id="redo-svg0">
                <Redo2Icon></Redo2Icon>
              </Button>
            </div>
            <div className=''>
              <label>SELECIONAR</label>
              <Button className="w-full bg-transparent" id="select-mode">
                <MousePointer2Icon></MousePointer2Icon>
              </Button>
            </div>
            <div>
              <label>DESELECIONAR TUDO</label>
              <Button className="w-full bg-transparent" id="deselect-mode">
                <MousePointer2OffIcon></MousePointer2OffIcon>
              </Button>
            </div>
            <div>
              <label>REAJUSTAR</label>
              <Button className="w-full bg-transparent" id="canvas-default-size">
                <SearchIcon></SearchIcon>
              </Button>
            </div>
            <div>
              <label>LIMPAR SVG</label>
              <Button className="w-full bg-transparent" id="clear_svg">
                <TrashIcon></TrashIcon>
              </Button>
            </div>
            <div>
              <label>GRADE</label>
              <Button className="w-full bg-transparent" id="toggle-grid">
                <GridIcon></GridIcon>
              </Button>
            </div>
          </section>
        </div>

        <div id='svg-editor-positions'>
          <span id='position-main' data-pos="jogador">JOGADOR</span>
          <span id='position-sub1' data-pos="goleiro">GOLEIRO</span>
          <span id='position-sib2' data-pos="passeio">PASSEIO</span>
        </div>

        <div id="panel-crop">
          <div className="image_container">
            <img id="blah" src="#" alt="your image" />
          </div>
          {/**Cropped image to display (only if u want) */}
          <div id="cropped_result"></div>
          <div id="crop-buttons">
            <button id="crop_button">
              <i className="fas fa-cut"></i>
            </button>
            <button id="close_crop">
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div id="externalObject">
          <span>Clique duas vezes no ponto que deseja adicionar anotação</span>
        </div>

        <Notification notification={notification} setNotification={setNotification} />

        <Toolbar activeTool={activeTool}>
          <button className='hover:bg-primary hover:text-background' id="svg-editor-state-back"><ArrowBack></ArrowBack></button>
          <ModularPartSelector />
          <button className='hover:bg-primary hover:text-background' data-title="TextBox" name="textbox" title={__('TextBox')} onClick={() => setActiveTool('textbox')}><TypeIcon></TypeIcon></button>
          <button className='hover:bg-primary hover:text-background' data-title="UploadImage" name="upload" title={__('UploadImage')} onClick={() => setActiveTool('upload')}><UploadIcon></UploadIcon></button>
          <button className='hover:bg-primary hover:text-background' data-title="colorsParent" name="color" title={__('colorsParent')} onClick={() => setActiveTool('color')}><PaintBucketIcon></PaintBucketIcon></button>
          <button className='hover:bg-primary hover:text-background' data-title="patternsParent" name="patternsParent" title={__('patternsParent')} onClick={() => setActiveTool('patternsParent')}><SquareAsteriskIcon></SquareAsteriskIcon></button>
          <button className='hover:bg-primary hover:text-background' data-title="EditorExtras" name="editorextras" title={__('TextBox')} onClick={() => setActiveTool('editorextras')}>
            <ShapesIcon></ShapesIcon>
          </button>
          <button className='hover:bg-primary hover:text-background' data-title="DTF" name="DTF" title={__('DTF')} onClick={() => setActiveTool('DTF')}>
            DTF
          </button>
        </Toolbar>

        <ToolPanel visible={activeSelection || (
          activeTool !== '' && activeTool !== '' && activeTool !== ''
        )}>

          {activeTool === 'background' && !activeSelection && <CanvasSettings canvas={canvas} />}

          {activeTool === 'draw' && !activeSelection && <DrawSettings canvas={canvas} />}

          {activeTool === 'shapes' && !activeSelection && <Shapes canvas={canvas} />}

          {activeTool === 'layers' && !activeSelection && <Layers canvas={canvas} />}

          {activeSelection && <SelectionSettings canvas={canvas} activeSelection={activeSelection} />}

          <div className='toolpanel_panel p-0 h-full' id="UploadImage">
            <UploadSettings canvas={canvas} />
          </div>

          <div className='toolpanel_panel rounded-[0px]' id="TextBox">
            <TextScreen></TextScreen>
          </div>

          <div className='toolpanel_panel p-0 h-full' id="EditorExtras">
            <EditorExtras canvas={canvas}></EditorExtras>
          </div>

          <div className='toolpanel_panel p-0 h-full' id="DTF">
            <DTF canvas={canvas}></DTF>
          </div>

          <div className='toolpanel_panel p-0' id="colorsParent">
            <ColorRandom></ColorRandom>
          </div>

          <div id="minimizer-svg-editor"></div>

          <div className='toolpanel_panel' id="encaixe">
            <p className="title">{__('ENCAIXES IFRAME')}</p>
            <button id='add-encaixe'>Adicionar ponto de encaixe</button>
            <div id='lista-encaixes'>

            </div>
          </div>

          <div className='toolpanel_panel p-0' id="patternsParent">
            <ClipartsScreen></ClipartsScreen>
          </div>
        </ToolPanel>

        <FabricCanvas canvas={canvas} setCanvas={setCanvas}
          selectionInfo={selectionInfo} setSelectionInfo={setSelectionInfo}
          setActiveSelection={setActiveSelection}
          setHistory={setHistory} />

        <div className="bottom-info">
          <IconZoom />
          <select onChange={(e) => { setZoom(e.target.value); applyZoom(canvas, e.target.value); }} value={zoom}>
            {zoomOptions.map((z, index) => {
              if (index === 0 && !zoomOptions.includes(Number(zoom))) {
                return (<option key={zoom} value="">{Number(zoom * 100).toFixed(0)}%</option>)
              }

              return (
                <option key={z} value={z}>{Number(z * 100).toFixed(0)}%</option>
              )
            })}
          </select>
        </div>
      </div>

      <video id="holograma-source">
        <source src="" type="video/mp4"></source>
      </video>

      {/**<div id="logo-mantos"></div> */}
      <div id="container">
        <div id="background-panel"></div>
        {/**<div id="banner_print_top" className='banners'></div>
        <div id="banner_print_bottom" className='banners'></div> */}
      </div>

      <ProjectsModal open={isModalOpen} onOpenChange={setIsModalOpen} />

      <IframeOrdersModal open={isIframeOrdersOpen} onOpenChange={setIsIframeOrdersOpen} />

      <SaveProjectModal
        open={isSaveModalOpen}
        onOpenChange={setIsSaveModalOpen}
        currentProject={currentProjectData}
        onSave={(data) => {
          window["SetProjectName"](data);
          window["saveProjectInput"]()
        }}
        onEdit={async (data) => {
          window.editProjectMeta = { productionOrder: data.productionOrder, filePath: data.filePath };
          if (window["editCurrentProject"]) {
            await window["editCurrentProject"](data.projectName);
          }
        }}
      />

      <AdminDashboard open={isAdminOpen} onOpenChange={setIsAdminOpen} />
    </div>
  )
}

export default Simulator